"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanContextService = void 0;
const models_1 = require("@buildwithflux/models");
const context_1 = require("../functions/context");
/**
 * Service for resolving the entitlement context for a given account context
 *
 * The reason this needs "resolution" is that the entitlement context contains more information, such as the user and/or
 * organization private metadata.
 *
 * Only the backend should use this service because, in the frontend, much of this information is already available and
 * loaded (e.g. the user private metadata, and the organization memberships of the current user). The recommended
 * approach, there, is to use the hooks, like useEntitlementContext()
 */
class PlanContextService {
    userPrivateMetadataRepository;
    organizationRepository;
    enterpriseRepository;
    stripeClientMode;
    constructor(userPrivateMetadataRepository, organizationRepository, enterpriseRepository, stripeClientMode) {
        this.userPrivateMetadataRepository = userPrivateMetadataRepository;
        this.organizationRepository = organizationRepository;
        this.enterpriseRepository = enterpriseRepository;
        this.stripeClientMode = stripeClientMode;
    }
    /**
     * Resolves the entitlement context for the given account
     */
    async getEntitlementContextForAccountContext({ account, currentUser, }) {
        const userContext = (0, context_1.getUserContextFromParts)(currentUser, (await this.userPrivateMetadataRepository.getForUser(currentUser.uid)) ?? { uid: currentUser.uid }, this.stripeClientMode);
        if ((0, models_1.accountIsUser)(account)) {
            return userContext;
        }
        if ((0, models_1.accountIsOrganization)(account)) {
            const membership = await this.organizationRepository.getOrganizationMember(account.uid, currentUser.uid);
            if (!membership) {
                throw new Error(`No membership found for user ${currentUser.uid} within organization ${account.uid}`);
            }
            const decoratedMembership = await this.enterpriseRepository.fullyDecorateOrganizationMember(membership);
            if ((0, models_1.isEnterpriseFullyDecoratedOrganizationMember)(decoratedMembership)) {
                return (0, context_1.getEnterpriseContextFromParts)(userContext, decoratedMembership);
            }
            else {
                return (0, context_1.getOrganizationContextFromParts)(userContext, decoratedMembership);
            }
        }
        if ((0, models_1.accountIsEnterprise)(account)) {
            const membership = await this.organizationRepository.getOrganizationMember(account.defaultOrganizationUid, currentUser.uid);
            if (!membership) {
                throw new Error(`No membership found for user ${currentUser.uid} on default organization ${account.defaultOrganizationUid} within enterprise ${account.uid}`);
            }
            const decoratedMembership = await this.enterpriseRepository.fullyDecorateOrganizationMember(membership);
            if (!(0, models_1.isEnterpriseFullyDecoratedOrganizationMember)(decoratedMembership)) {
                throw new Error(`Expected enterprise membership for user ${currentUser.uid} on default organization ${account.defaultOrganizationUid} within enterprise ${account.uid}`);
            }
            return (0, context_1.getEnterpriseContextFromParts)(userContext, decoratedMembership);
        }
        throw new Error("Unknown account type");
    }
}
exports.PlanContextService = PlanContextService;
//# sourceMappingURL=PlanContextService.js.map